import axios from "axios";
import { Text } from "components";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import pdfMake from "pdfmake/build/pdfmake";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver"; // Install file-saver if you don't have it: npm install file-saver
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  Rectangle,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";


function SupplierPoReport() {

  // Get today's date
  // const today = new Date();
  // const formattedToday = today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  // const thirtyDaysAgo = new Date(today);
  // thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  // const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split('T')[0]; // Format as YYYY-MM-DD

  const today = new Date();
  const formattedToday = today.toISOString().split('T')[0];
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(1); // Set to the first day of the current month
  thirtyDaysAgo.setMonth(thirtyDaysAgo.getMonth() -1); // Go back one month
  const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split('T')[0];

  const [companyPurchase, setCompanyPurchase] = useState([]);
  const [companyPurchesOrderCode, setCompanyPurchesOrderCode] = useState();
  const [suppierList, setSupplierList] = useState([]);
  const [suppierId, setSupplierId] = useState();
  const [companyPurchasOrderId, setCompanyPurchasOrderId] = useState();

  const [download, setDownload] = useState(false);
  const [toDate, setToDate] = useState(formattedToday);
  const [fromDate, setFormDate] = useState(formattedThirtyDaysAgo);
  const [showChart, setShowChart] = useState(false);
  const [flag, setFlag] = useState(false)
  const [timedateflag, setTimeDateFlag] = useState(false);
  const [resetkey, setResetKey] = useState(0);


  const [supplierPOFlag, setSupplierPOFlag] = useState(false);
  const [supplierSelectionFlag, setSupplierSelectionFlag] = useState(false);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    companyPurchaseGet();
  }, [fromDate, toDate, suppierId]);

  const obj = {
    from_date: fromDate,
    to_date: toDate,
    supplier_id: suppierId,
    company_purchase_order_id: companyPurchasOrderId
  };
  const companyPurchaseGet = () => {
    axios
      .post("/api/purple-fusion/companypurchaseorderreport/get/componypurchaseorder/all", obj, headers)
      .then((response) => {
        setCompanyPurchase(response.data);
        console.log(response.data)
        if (response.data.length > 0) {
          setShowChart(true)
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };

  //for getting list of supplier...
  useEffect(() => {
    setTimeout(() => {
      SupplierGet();
    }, 500);
  }, []);
  const obj1 = {};
  const SupplierGet = () => {
    axios
      .post("/api/purple-fusion/companypurchaseorderreport/get/supplier", obj1, headers)
      .then((response) => {
        setSupplierList(response.data);
        console.log(response.data)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //for resetting the code field
  useEffect(() => {
    setResetKey(prev => prev + 1);
  }, [toDate, fromDate, suppierId]);

  const filteredPurchase = companyPurchase.filter((purchase) => {
    return purchase.code === companyPurchesOrderCode;
  });
  const id = filteredPurchase.length > 0 ? filteredPurchase[0].id : null;


  //for pdf and excel download title..(timeStapm)
  const [dateTime, setDateTime] = useState('');
  useEffect(() => {
    const currentTimestamp = new Date();
    const formattedDate = currentTimestamp.toLocaleDateString([], {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).replace(/\//g, '-');
    const formattedDateTime = `${formattedDate}`;
    setDateTime(formattedDateTime);
    console.log(formattedDateTime);
  }, [timedateflag]);
  // for excel download.

  const DownloadExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Suppier PO Report');
    const dataSource = flag == false ? companyPurchase : filteredPurchase;
    const dateTime = new Date().toISOString().slice(0, 10); // Today's date
    // Format headers date
    const formatHeadersDate = (dateStr) => {
      const [year, month, day] = dateStr.split('-'); // Split the date string
      return `${day}-${month}-${year}`; // Return in DD-MM-YYYY format
    };
    // Add report title and date range at the top
    worksheet.addRow(['Report Name:', 'Suppier PO Report']);
    worksheet.addRow(['From Date:', formatHeadersDate(fromDate)]);
    worksheet.addRow(['To Date:', formatHeadersDate(toDate)]);
    if (supplierPOFlag == true) {
      worksheet.addRow(['Supplier Name:', companyPurchase[0].suppliername]);
    }
    else {
      worksheet.addRow([]); // Empty row for spacing
    }
    if (supplierSelectionFlag == true) {
      worksheet.addRow(['Supplier PO Code:', companyPurchesOrderCode]);
    }
    else {
      worksheet.addRow([]); // Empty row for spacing
    }
    worksheet.addRow([]); // Empty row for spacing

    // Define headers with 'SR.NO' and other columns
    const headers = ['Sr.No', 'Supplier Name', 'Code', 'Item Name', 'Supplier PO Qty', 'Received Qty'];
    worksheet.addRow(headers);

    // Freeze the top 5 rows (title and header)
    worksheet.views = [{ state: 'frozen', ySplit: 7 }];

    // Apply bold font and left alignment to the first 3 rows of column 1
    for (let i = 1; i <= 6; i++) {
      const cell = worksheet.getCell(i, 1); // Get cell in column 1
      cell.font = { bold: true }; // Make text bold
    }
    // Apply styles to the header row (5th row)
    worksheet.getRow(7).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // white text color
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF368BC1' } // blue background color
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });
    // Apply styles to the first 4 rows (title and date rows)
    for (let i = 1; i <= 6; i++) {
      const row = worksheet.getRow(i);
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFFFF' } // white background
        };
      });
    }
    // Remove gridlines for the first 4 rows by setting the fill to match the background
    for (let i = 1; i <= 6; i++) {
      for (let j = 1; j <= headers.length; j++) {
        const cell = worksheet.getRow(i).getCell(j);
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFFFFFF' } // white background
        };
      }
    }
    // Add data to worksheet as arrays with numeric values
    dataSource.forEach((revenue, index) => {
      worksheet.addRow([
        index + 1,
        revenue.suppliername,
        revenue.code,
        revenue.item_name,
        Number(revenue.quantity), // Convert to number
        Number(revenue.quantityforstockalloteditems), // Convert to number

      ]);
    });

    // Save the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer]), `PO Report ${dateTime}.xlsx`);
    }).catch((error) => {
      console.error("Error saving Excel file:", error);
    });
  };

  // Custom Bar Component for combine sales_order_qty and Tax_invoice_qty
  const CustomBar = (props) => {
    const { x, y, width, height, fill, payload } = props;
    const companyPOQuantity = payload.quantity;
    const stockQuntity = payload.quantityforstockalloteditems;
    // Calculate the width of the tax invoice portion
    const taxWidth = (width * stockQuntity) / companyPOQuantity;

    // Calculate the percentage
    const percentage = ((stockQuntity / companyPOQuantity) * 100).toFixed(1);

    return (
      <g>
        {/* Main bar for sales_order_item_quantity */}
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill={fill}
        />
        {/* Overlay bar for tax_invoice_quantity */}
        {stockQuntity > 0 && (
          <rect
            x={x}
            y={y}
            width={taxWidth}
            height={height}
            fill="#82ca9d"
          />
        )}

        {/* Percentage text at the start of the bar */}
        <text
          x={x + 50} // Slight offset to avoid touching the bar's edge
          y={y + height / 2}
          textAnchor="start" // Align text to the start
          dominantBaseline="middle"
          fill="#000"
          fontSize="12px"
        >
          {percentage}%
        </text>
      </g>
    );
  };

  // Custom tooltip component
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0] ? payload[0].payload : {};
      console.log(data);

      return (
        <div className="custom-tooltip" style={{ backgroundColor: 'white', padding: '5px', border: '1px solid #ccc' }}>
          {flag == false && <p>{`PO Code:${payload[0].payload.code}`}</p>}
          <p>{`Supplier Name: ${data.suppliername}`}</p>
          <p>{`Item: ${label}`}</p>
          <p>{`Total Quantity: ${data.quantity}`}</p>
          <p>{`Received Quntity: ${data.quantityforstockalloteditems}`}</p>

          {/* Additional tooltip displaying delivery date */}
          <p>{`Completed(%): ${((data.quantityforstockalloteditems / data.quantity) * 100).toFixed(1) + "%" || 'N/A'}`}</p>

        </div>
      );
    }
    return null;
  };

  //show bar as per max value
  const data1 = flag == false ? companyPurchase : filteredPurchase;
  const maxValue = Math.max(
    ...data1.map(item => item.quantity)
  );
  return (
    <>
      <div className='w-full flex flex-col'>

        <div className="flex justify-between items-start mt-3 mx-3 gap-1">
          <div className="flex flex-row items-center w-full">

            <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2 mr-2 ml-2 mb-2 ">
              Form
            </Text>
            <input
              name="from_date"
              type="date"
              value={fromDate}
              onChange={(e) => {
                setFormDate(e.target.value);
              }}
              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] pt-4 "
            />
            <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2 mr-2 ml-2 mb-2 ">
              To
            </Text>

            <input
              name="to_date"
              type="date"
              value={toDate}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
              className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] pt-4"
            />
            <Select

              options={[
                { label: "All Supplier", value: "" },
                ...suppierList.map((suppier) => ({
                  label: suppier.name,
                  value: suppier.id,
                }))]}
              className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[20%]"
              onChange={(selectedOption) => {
                setSupplierId(selectedOption.value);


                if (selectedOption.value === "") {
                  setSupplierPOFlag(false);
                } else {
                  setSupplierPOFlag(true);
                }


              }}
              placeholder="All Supplier"

            />

            <Select
              options={[
                { label: "Supplier All PO", value: "" },

                ...Array.from(new Set(companyPurchase.map((purchase) => purchase.code))).map(code => ({
                  label: code,
                  value: code,
                }))
              ]}
              className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[25%]"
              onChange={(selectedOption) => {
                if (selectedOption.value == "") {
                  setFlag(false)
                }
                else {
                  setFlag(true)
                }
                setCompanyPurchesOrderCode(selectedOption.value);
                setShowChart(true);

                if (selectedOption.value === "") {
                  setSupplierSelectionFlag(false);
                } else {
                  setSupplierSelectionFlag(true);
                }
              }}
              placeholder="Select Code"
              key={resetkey}
            />
          </div>
          <div className="flex items-center ">
            <div
              className="flex flex-col relative z-20 "
              onMouseEnter={() => setDownload(true)}
              onMouseLeave={() => setDownload(false)}
            >
              <button
                id="dropdownDefaultButton"
                data-dropdown-toggle="dropdown"
                className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 w-28 mr-4 "
                type="button"
              >
                {"Download"} &nbsp;
                <svg
                  className="w-2.5 h-2.5 ms-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 10 6"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 4 4 4-4"
                  />
                </svg>
              </button>
              <div
                className={`${download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
              >
                <ul
                  className="py-0 text-sm text-gray-700 dark:text-gray-200"
                  aria-labelledby="dropdownDefaultButton"
                >
                  <li>
                    <a
                      className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      onClick={() => DownloadExcel()}
                    >
                      Excel
                    </a>
                  </li>
                
                </ul>
              </div>
            </div>
          </div>
        </div>

        {showChart && (
          <div className="w-[96%] h-full flex-col mt-2 ml-2 p-4 overflow-scroll border-2 shadow-lg">
            <ResponsiveContainer width="100%" height={350}>
              {/* <BarChart
                data={flag == false ? companyPurchase : filteredPurchase}
                margin={{
                  top: 50,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="item_name" />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Bar
                  dataKey="quantity"
                  name="Total Quantity"
                  fill="#8884d8"
                  activeBar={<Rectangle fill="pink" stroke="blue" />}
                />
                <Bar
                  dataKey="quantityforstockalloteditems"
                  name="Received Quntity"
                  fill="#82ca9d"
                  activeBar={<Rectangle fill="gold" stroke="purple" />}
                />
              </BarChart> */}

              <BarChart
                layout="vertical"
                data={flag == false ? companyPurchase : filteredPurchase}
                margin={{
                  top: 5,
                  right: 30,
                  // left:50,
                  bottom: 3
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <Legend
                  verticalAlign="bottom"
                  wrapperStyle={{ fontSize: '10px' }}
                />
                <ReferenceLine x={0} stroke="#000" />
                <XAxis
                  type="number"
                  tickFormatter={(value) => {
                    // Formats values in millions
                    if (value >= 1000000) {
                      return `${(value / 1000000).toFixed(1)}M`;
                    }
                    // Formats values in lakhs
                    else if (value >= 100000) {
                      return `${(value / 100000).toFixed(1)}L`;
                    }
                    // Formats values in thousands
                    else if (value >= 1000) {
                      return `${(value / 1000).toFixed(1)}K`;
                    }
                    // No formatting for values below 1000
                    else {
                      return value.toFixed(0);
                    }
                  }}
                  tick={{ fontSize: '12px' }}
                  label={{
                    style: { fontSize: '12px' }
                  }}
                  domain={[0, maxValue * 1.1]} // Sets domain based on maxValue

                />
                <YAxis
                  type="category"
                  dataKey="item_name"
                  tickFormatter={(itemName) => itemName.slice(0, 100)} // Shortens item name
                  tick={{
                    fontSize: '10px',
                    textAnchor: 'middle',
                    angle: 0,
                    dy: 0,
                    dx: -150,
                  }}
                  width={320}
                />
                <Tooltip
                  content={<CustomTooltip />}
                  wrapperStyle={{ fontSize: '10px' }}
                />

                <Bar
                  dataKey="quantity"
                  name="Total Quantity"
                  fill="#8884d8"
                  barSize={40}
                  shape={<CustomBar />}
                >
                  <LabelList
                    dataKey="quantity"
                    position="right"
                    formatter={(value) => Number(value).toFixed(2)}
                    style={{ fontSize: '12px' }}
                  />
                </Bar>
              </BarChart>

            </ResponsiveContainer>
            {flag == true
              && <div className="flex flex-row justify-center items-center mt-3">
                <h1 className="font-bold text-sm">Supplier Name:</h1><h1 className="text-sm">{filteredPurchase[0]?.suppliername}</h1>
                <h1 className="font-bold text-sm ml-4">Code:</h1><h1 className="text-sm">{filteredPurchase[0]?.code}</h1>
              </div>}

          </div>
        )}
      </div>
    </>
  );
}

export default SupplierPoReport;
